import settings from "@/app/settings";

const DEFAULT_AVATAR = `${settings.api}/theme/images/default-profile.jpg`;

export {
  DEFAULT_AVATAR
}